export default __webpack_public_path__ + "static/media/Dr. Vani.249a2f59.jpeg";